import { memo } from 'react'

import { useThemeStore } from '@/lib/store/useThemeStore'

import View from './ThemeToggle.view'

export interface ControllerProps {
  className?: string
}

export const Controller = memo(function ThemeToggleController({ className }: ControllerProps) {
  const preference = useThemeStore((state) => state.preference)
  const setPreference = useThemeStore((state) => state.setPreference)

  return <View className={className} preference={preference} onPreferenceChange={setPreference} />
})

Controller.displayName = 'ThemeToggle_Controller'

export default Controller
